import {
  CreateMediaData,
  ObservationResultSearch,
  ObservationResultsResponse,
  PathologyReportGetAllParams,
  PathologyReportGetAllResponse,
  PathologyReportGetResponse,
} from '@quromedical/models';
import { trpc } from 'trpc';

export class DiagnosticReportApi {
  getDiagnosticReports = async (
    params: PathologyReportGetAllParams
  ): Promise<PathologyReportGetAllResponse> =>
    await trpc.client.pathologyReport.getAll.query(params);

  getDiagnosticReport = async (id: string): Promise<PathologyReportGetResponse> =>
    await trpc.client.pathologyReport.getById.query({ id });

  getPresentedForm = async (id: string): Promise<CreateMediaData[]> =>
    await trpc.client.pathologyReport.getPresentedForm.query({ id });

  getDiagnosticResults = async (
    params: ObservationResultSearch
  ): Promise<ObservationResultsResponse> => await trpc.client.patient.getObservation.query(params);
}
